<template>
  <main>
    <FilmTabReport
      :loading="loading"
      :patient-info="patientInfo"
      :image-info="imageInfo"
      title="名医诊断报告"
    ></FilmTabReport>
  </main>
</template>

<script>
// description: 名医诊断的报告页面
// author: xiemm
import FilmTabReport from '../../components/FilmTabReport.vue';

export default {
  name: 'DoctorReport',
  components: {
    FilmTabReport,
  },
  data() {
    return {
      loading: true,
      patientInfo: {
        hospital_name: '',
        image_id: '',
        patient_name: '',
        gender: '',
        age: '',
      },
      imageInfo: {
        examination_report: '',
        examination_show: '',
      },
    };
  },
  async mounted() {
    const response = await this.$http.get('/cloud-film-api/webapi/order/get-order', {
      orderId: this.$route.params.id,
    });
    //
    const [day] = response.cloud_film_order.finish_time.split(' ');
    const patientInfo = {
      image_id: response.cloud_film_order.image_id,
      patient_name: response.order_other_vo.patient_name,
      gender: response.order_other_vo.gender,
      age: response.order_other_vo.age,
      check_item: response.order_other_vo.check_item,
      submitter_name: response.order_other_vo.submitter_name,
      submit_time: day,
    };
    this.patientInfo = patientInfo;
    // 报告
    this.imageInfo.examination_report = response.cloud_film_order.performance;
    this.imageInfo.examination_show = response.cloud_film_order.diagnosis;
    this.loading = false;
  },
};
</script>

<style scoped>

</style>

<style lang="scss" scoped>

</style>
